/**
 * Monta la hoja "Instala Fermin" una sola vez, en la raíz de rutas (`routes/__root.tsx`).
 *
 * Se abre solo a pedido: `openInstallGuide()` (card de Inicio, "Cómo instalar la app" en Perfil)
 * o `?instalar=ios26|ios18|ios-chrome|ipad|android` al cargar, para QA y escritorio. En `/instalar`
 * el parámetro no abre la hoja: esa pantalla ya muestra la guía (y usa la variante forzada).
 */
import { useEffect, useState } from 'react';

import { InstallSheet } from './install-sheet';
import { forcedVariant, OPEN_EVENT, type OpenGuideDetail } from './variants';

interface Request extends OpenGuideDetail {
  id: number;
}

function initialRequest(): Request | null {
  if (typeof window === 'undefined' || window.location.pathname === '/instalar') {
    return null;
  }
  const variant = forcedVariant(window.location.search);
  return variant ? { id: 0, variant } : null;
}

export function InstallHost() {
  const [request, setRequest] = useState<Request | null>(initialRequest);

  useEffect(() => {
    let next = 1;
    function onOpen(event: Event): void {
      const detail = (event as CustomEvent<OpenGuideDetail | undefined>).detail ?? {};
      setRequest({ ...detail, id: next++ });
    }
    window.addEventListener(OPEN_EVENT, onOpen);
    return () => window.removeEventListener(OPEN_EVENT, onOpen);
  }, []);

  if (!request) {
    return null;
  }
  return (
    <InstallSheet
      key={request.id}
      open
      forced={request.variant}
      manual={request.manual}
      enrolled={request.enrolled}
      onClose={() => setRequest(null)}
    />
  );
}
